/*! Copyright (c) Safe As Milk. All rights reserved. */
class DetailsDisclosure extends HTMLElement {
    constructor() {
        super();
        this.mainDetailsToggle = this.querySelector("details");
        // Defensive guards: a malformed `<details-disclosure>` (no <details>,
        // or a <details> with just a <summary> and no sibling content) used
        // to crash later with "Cannot read properties of null (reading
        // 'getAnimations')". Bail early so the rest of the page still works.
        if (!this.mainDetailsToggle) return;
        const summaryEl = this.mainDetailsToggle.querySelector("summary");
        this.content = summaryEl ? summaryEl.nextElementSibling : null;
        this.mainDetailsToggle.addEventListener("focusout", this.onFocusOut.bind(this));
        this.mainDetailsToggle.addEventListener("toggle", this.onToggle.bind(this));
    }
    onFocusOut() {
        setTimeout((() => {
            if (!this.contains(document.activeElement)) this.close();
        }));
    }
    onToggle() {
        if (!this.content) return;
        if (!this.animations) this.animations = this.content.getAnimations();
        if (this.mainDetailsToggle.hasAttribute("open")) {
            this.animations.forEach((animation => animation.play()));
        } else {
            this.animations.forEach((animation => animation.cancel()));
        }
    }
    close() {
        if (!this.mainDetailsToggle) return;
        this.mainDetailsToggle.removeAttribute("open");
        const summaryEl = this.mainDetailsToggle.querySelector("summary");
        if (summaryEl) summaryEl.setAttribute("aria-expanded", false);
    }
}

customElements.define("details-disclosure", DetailsDisclosure);

export default DetailsDisclosure;
//# sourceMappingURL=details-disclosure.js.map
